import React from 'react';
import { Text } from '@tamagui/core';
import { XStack, YStack } from '@tamagui/stacks';
import { COLORS } from '@/constants/colors';
import { FONT_SIZE_SECTION, ITEM_GAP } from '../constants';
import Tag from './Tag';

type TagsSectionProps = {
  tags: Array<{ text: string; checked?: boolean }>;
  isDark?: boolean;
};

const TagsSection = React.memo<TagsSectionProps>(({ tags, isDark }) => {
  const textColor = isDark ? COLORS.WHITE : COLORS.ZINC_900;
  
  return (
    <YStack gap={ITEM_GAP}>
      <Text fontSize={FONT_SIZE_SECTION} fontWeight="700" color={textColor}>
        Zainteresowania
      </Text>
      <XStack flexWrap="wrap" gap={ITEM_GAP}>
        {tags.map((tag, index) => (
          <Tag key={index} text={tag.text} checked={tag.checked} isDark={isDark} />
        ))}
      </XStack>
    </YStack>
  );
});

TagsSection.displayName = 'TagsSection';

export default TagsSection;

